













































































































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import RevisitApi from '@/api/revisit'
import addResurvey from './addResurvey/addResurvey.vue'
import addMotion from './addResurvey/addMotion.vue'
import actionCol from './actionCol.vue'
import { RESURVEY, MOTION, NEW_MOTION, SHOU_HOU, WEI_JUE } from '@/utils/const'
import moment from 'moment'

@Component({
	name: 'returnVisitList',
	components: {
		PageLayout,
		addResurvey,
		addMotion,
		actionCol,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false
	private SHOU_HOU = SHOU_HOU
	private WEI_JUE = WEI_JUE
	private RESURVEY = RESURVEY
	private MOTION = MOTION
	private NEW_MOTION = NEW_MOTION
	private addVisible = false
	private clickedRow: any = {}

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	public getList() {
		return RevisitApi.getList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	private get revisitAuthObj() {
		return {
			ShouHouOp: this.$auth('returnVisitList:operation'),
			WeiJueOp: this.$auth('revisitTrack:operation'),
			ShouHouStart: this.$auth('returnVisitDetail:begin'),
			WeiJueStart: this.$auth('revisitTrack:begin'),
			addResurvey: this.$auth('returnVisitList:addResurvey'),
			addMotion: this.$auth('returnVisitList:addMotion'),
			trackDetail: true,
		}
	}

	private get initialTaskRange() {
		return [
			moment()
				.startOf('day')
				.subtract(2, 'month'),
			moment().startOf('day'),
		]
	}

	private showModal(row: any) {
		this.addVisible = true
		this.clickedRow = row
	}

	public activated() {
		this.$store.dispatch('setting/initPartnerTree')
		this.getList()
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()

		if (form.rangeTime) {
			form.startTime =
				form.rangeTime[0] && form.rangeTime[0].format('YYYY-MM-DD')
			form.endTime = form.rangeTime[1] && form.rangeTime[1].format('YYYY-MM-DD')
			delete form.rangeTime
		}

		if (form.taskRangeTime) {
			form.taskStartTime =
				form.taskRangeTime[0] && form.taskRangeTime[0].format('YYYY-MM-DD')
			form.taskEndTime =
				form.taskRangeTime[1] && form.taskRangeTime[1].format('YYYY-MM-DD')
			delete form.taskRangeTime
		}

		return form
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	private exportList() {
		this.exportingList = true
		RevisitApi.exportList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
